var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataScience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.7 86.7",
    style: {
      enableBackground: "new 0 0 86.7 86.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.2,32.3c-0.3,0.6-0.6,1.3-0.8,1.9c-0.2,0.7-0.4,1.3-0.6,2c-0.3,1.4-0.5,2.8-0.5,4.2c0,1.4,0.3,2.8,0.8,4.1 c0.1,0.3,0.3,0.6,0.4,1c0.2,0.3,0.3,0.6,0.5,0.9c0,0.1,0.1,0.2,0.1,0.2l0.2,0.2c0.1,0.1,0.2,0.3,0.3,0.4s0.4,0.6,0.7,0.8l0,0 c-1-1-1.8-2.2-2.4-3.5c-0.1-0.3-0.2-0.7-0.4-1s-0.2-0.7-0.2-1c-0.1-0.7-0.2-1.4-0.2-2.1c0-1.4,0.2-2.8,0.5-4.2 c0.2-0.7,0.4-1.3,0.6-2C32.5,33.6,32.8,33,33.2,32.3L33.2,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,52.9h3.6l0,0c-7.1-4.2-9.5-13.4-5.3-20.5c2.7-4.6,7.6-7.4,12.9-7.4c0.7,0,1.4,0,2.1,0.1 c-8.7-1.6-17,4.1-18.7,12.8C25.7,43.5,27.6,49.2,32,52.9L32,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.2,40l-2.2-2.9l-1.5,3.1c0,0,1-0.3,1.2-0.1c0.1,3.6-1.1,7.1-3.3,10v2.2c2.9-3,4.6-7,4.5-11.2 c0-0.3,0-0.7,0-1C59.4,40,59.8,40,60.2,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.5,49.9h4v12h-4V49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.5,45.7h4v16.2h-4V45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.5,48.5h4v13.3h-4V48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,51.7h3.4v10.2h-4v-9.5C36.6,52,36.9,51.7,37.2,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.6,53.4h4v8.5h-4V53.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,31.1c-1.6,0.2-2.8,1.4-3,3c-0.1-0.8-0.5-1.6-1.1-2.2c-0.6-0.5-1.3-0.8-2-0.9c1.5-0.3,2.7-1.5,3-3 C52.1,29.6,53.4,30.8,54.9,31.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScience);
export default __webpack_public_path__ + "static/media/data-science.cf04730d30f39ca8ba226b128d61fbdf.svg";
export { ForwardRef as ReactComponent };